import React, { useContext, useState } from 'react'
import '../index.scss'
import ProfileAccountInfoSection from '@Components/ProfileAccountInfoSection'
import GetVerifiedPopup from '@Components/Popups/GetVerifiedPopup'
import ModalPortal from '@Components/Popups/ModalPortal'
import { StoresContext } from '@App/contexts'
import RootStore from '@App/stores/root-store'
import { UserInfo } from '@Entities/user/user'
import UserInfoSection from '@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserView/UserInfoSection'
import AddressSection from '@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserView/AddressSection'
import TopSection from '@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserView/TopSection'
import ContactInfoSection from '@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserView/ContactInfoSection'
import { useNavigate } from 'react-router'
import { USER_VERIFICATION_STATUSES } from '@Const/user-statuses'
import { userinfoToZodMapper } from '@App/helpers/userinfo-to-zod-mapper'
import { userInfoSchema } from '@Entities/schemas/user/user-info-schema'
import { KYC_ROUTE } from '@App/navigation/route'

interface ProfileSceneUserViewProps {
    setEditable: (editable: boolean) => void
}

const ProfileSceneUserView = (props: ProfileSceneUserViewProps) => {
    const { setEditable } = props
    const { userStore } = useContext<RootStore>(StoresContext)

    const navigate = useNavigate()
    const userInfo: UserInfo = userStore.userInfo
    const isInternal = Boolean(userInfo.isInternal)
    const phoneNumberTitle: string = userStore.phoneNumberDisplay
    const countryTitle: string = userStore.countryTitle

    const [getVerifiedPopupIsOpen, setGetVerifiedPopupIsOpen] = useState<boolean>(false)

    const getVerified = () => {
        if (!profileReadyForKyc()) {
            setGetVerifiedPopupIsOpen(true)
        }
        userStore.attemptIdvForSignedInUser().then(() => {
            navigate(`/${KYC_ROUTE}?` + userStore.getAu10TixWorkflowLinkParams())
        })
    }

    const profileReadyForKyc = () => {
        if (!userInfo || userInfo.verificationStatus === USER_VERIFICATION_STATUSES.REJECTED) {
            return false
        }
        const zodMappedData = userinfoToZodMapper(userInfo)
        return userInfoSchema.safeParse(zodMappedData).success
    }

    return (
        <div className="profile-scene-user-tab">
            <TopSection userInfo={userInfo} isInternal={isInternal} onClick={() => setEditable(true)} />
            <ProfileAccountInfoSection getVerified={getVerified} userInfo={userInfo} />
            <UserInfoSection userInfo={userInfo} />
            <AddressSection userInfo={userInfo} countryTitle={countryTitle} />
            <ContactInfoSection userInfo={userInfo} phoneNumberTitle={phoneNumberTitle} />
            <ModalPortal isOpen={getVerifiedPopupIsOpen}>
                <GetVerifiedPopup
                    status={userInfo.verificationStatus}
                    onCloseConfirmPopup={() => setGetVerifiedPopupIsOpen(false)}
                    clickEditProfile={() => setEditable(true)}
                />
            </ModalPortal>
        </div>
    )
}

export default ProfileSceneUserView
